import { Link } from "react-router-dom";
import { SaaSConsoleType } from "@doitintl/cmp-models";
import { Box, Card, CardHeader, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { homeTexts } from "../../../assets/texts";
import { headerMap } from "../../../Components/Dashboard/CloudConnection/consts";
import mixpanel from "../../../utils/mixpanel";
import useSegmentTrackEvent from "../../../utils/useSegmentTrackEvent";

export const CloudConnectCard = ({
  logo,
  cloudType,
  route,
}: {
  logo: string;
  cloudType: SaaSConsoleType;
  route: string;
}) => {
  const theme = useTheme();
  const {
    palette: { primary },
  } = theme;
  const { trackEvent } = useSegmentTrackEvent();

  const handleClick = () => {
    // Track mixpanel event (existing)
    mixpanel.track(`home.cloud-connect.${cloudType}.click`, { $referrer: location.href });

    // Track segment events based on cloud type
    if (cloudType === SaaSConsoleType.AWS) {
      trackEvent("Cloud Diagrams", {
        source: "Home Dashboard",
        feature: "Home Dashboard",
        target_internal_destination_description: "Build diagrams for your AWS account button",
      });
    } else if (cloudType === SaaSConsoleType.GCP) {
      trackEvent("Cloud Flow", {
        source: "Home Dashboard",
        feature: "Home Dashboard",
        target_internal_destination_description: "Get started with pre-built blueprints button",
      });
    } else {
      // Generic tracking for other cloud types
      trackEvent("Insights", {
        source: "Home Dashboard",
        feature: "Home Dashboard",
        target_internal_destination_description: "View cloud optimization opportunities button",
      });
    }
  };

  const cardContent = (
    <Typography
      variant="body2"
      sx={{
        color: "text.secondary",
      }}
    >
      {homeTexts.CLOUD_CONNECT_CARD_CONTENT(headerMap[cloudType])}
    </Typography>
  );

  return (
    <Link to={route} style={{ textDecoration: "none" }} onClick={handleClick}>
      <Card sx={{ "&:hover": { borderColor: primary.main }, height: "100%" }}>
        <CardHeader
          sx={{ alignItems: "start" }}
          titleTypographyProps={{ variant: "subtitle1", fontWeight: 500 }}
          avatar={<Box component="img" src={logo} sx={{ height: 24, width: 24 }} />}
          title={homeTexts.CLOUD_CONNECT_CARD_TITLE(headerMap[cloudType])}
          subheader={cardContent}
        />
      </Card>
    </Link>
  );
};
